import React, { useContext, useRef } from 'react';
import { StyleSheet, Text } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';
import { useOverflowStyle } from '../../hooks/useOverflowStyle';

const H5 = ({ numberOfLines = 1, onPress, style, text, ...rest }) => {
    const { layout } = useContext(LayoutContext);
    const ref = useRef();
    const overflowStyle = useOverflowStyle(ref, layout.styleGuide.h5);

    return (
        <Text
            {...rest}
            adjustsFontSizeToFit={true}
            dataSet={{
                tagName: 'H5',
                fontFamily: layout.styleGuide.h5.fontFamily,
                condensedFontFamily: layout.styleGuide.h5.condensedFontFamily,
                fontSize: layout.styleGuide.h5.fontSize,
                color: layout.styleGuide.h5.color
            }}
            numberOfLines={numberOfLines === null ? undefined : numberOfLines}
            onPress={onPress}
            ref={ref}
            style={StyleSheet.flatten([Style.h5, layout.styleGuide.h5, overflowStyle, style])}
        >
            {text}
        </Text>
    );
};

const Style = StyleSheet.create({
    h5: {
        color: '#000',
        fontFamily: 'GothamBook',
        fontSize: '13pt'
    }
});

H5.propTypes = {
    numberOfLines: PropTypes.number,
    style: PropTypes.object,
    text: PropTypes.string
};

export default H5;
